import {
  Button,
  CircularProgress,
  ListItem,
  Typography,
  useTheme,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useMutation, useQuery } from "react-query";
import { useContext, useEffect } from "react";
import {
  getConcultationDetails,
  getConsultationCode,
  getVisitType,
  updateConsultation,
} from "../../services";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";
import { EmrContext } from "../../index";
function Complaints() {
  const theme = useTheme();
  const { user } = useAuthentication();
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const { page, triggerConsultationStart } = useContext(EmrContext);
  const { control, handleSubmit, reset } = useForm();
  const { data: consultationCode, isLoading: consultationCodesLoading } =
    useQuery(
      ["getAllCptInputsForComplaints"],
      async () => {
        return await getConsultationCode({
          groupId: 3,
          search: "",
          clinicId: user?.clinicId as number,
        });
      },
      { refetchOnWindowFocus: false },
    );
  const { data: consultationData, isLoading: consultationDetailsLoading } =
    useQuery(
      ["fetchConsultationDetails", encounterId],
      async () => await getConcultationDetails(String(encounterId)),
      {
        refetchOnWindowFocus: false,
      },
    );
  const { data: visitType, isLoading: visitTypeLoading } = useQuery(
    ["visitTypeInCounsultation"],
    getVisitType,
  );
  const { mutate: consultationUpdate, isLoading } = useMutation(
    updateConsultation,
    {
      onSuccess: (data) => {
        const isSuccess = data.responseIndicator === "success";
        const variant = isSuccess ? "success" : "error";
        const message = isSuccess
          ? "Consultation updated successfully"
          : "Failed to update consultation";

        showSnackbar({
          open: true,
          variant,
          message,
          duration: 2000,
        });
        if (isSuccess) {
          triggerConsultationStart();
        }
      },
    },
  );

  const onSubmit = (value: any) => {
    const body = {
      fromVerification: Boolean(page == "verification"),
      clinicId: user?.clinicId as number,
      encounterId: parseInt(encounterId as string),
      cptId: value.consultationCode.cpt_id
        ? value.consultationCode.cpt_id
        : consultationData?.response?.cpt_id,
      visitType: value?.visitType?.id,
    };
    consultationUpdate(body);
  };
  useEffect(() => {
    if (
      consultationData?.responseIndicator == "success" &&
      consultationData?.response
    ) {
      const visitTypeFinded = visitType?.response?.find(
        (item) => item.id == consultationData?.response?.visitType,
      );
      reset({
        visitType: visitTypeFinded,
        consultationCode: { cpt_code: consultationData?.response.cpt_code },
      });
    }
  }, [visitType, consultationData]);
  return (
    <div className="border-2 rounded">
      <div className="p-1 border-b rounded-t">
        <Typography color={theme.palette.primary.main} fontWeight={600}>
          Consultation
        </Typography>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="p-2 grid grid-cols-12 gap-3"
      >
        <div className="col-span-4">
          <CustomFormField
            name="visitType"
            loading={visitTypeLoading}
            control={control}
            element="autocomplete"
            fieldProps={{ label: "Visit Type" }}
            rules={{ required: "Visit Type reuired" }}
            options={visitType?.response || []}
            autocompleteProps={{
              disabled: consultationDetailsLoading,
              getOptionLabel: (option) => option.visitType,
            }}
          />
        </div>
        <div className="col-span-6 ">
          <CustomFormField
            name="consultationCode"
            control={control}
            element="autocomplete"
            fieldProps={{ label: "Consultation" }}
            loading={consultationCodesLoading}
            rules={{ required: "Consultation code reuired" }}
            options={consultationCode?.response || []}
            autocompleteProps={{
              disabled: consultationDetailsLoading,
              isOptionEqualToValue: (option, value) =>
                option.cpt_code == value.cpt_code,
              getOptionLabel: (option) => option.cpt_code,
              renderOption: (props, option) => (
                <ListItem {...props}>
                  {option.cpt_code} | {option.cpt_name}
                </ListItem>
              ),
            }}
          />
        </div>

        <div className="flex  items-center gap-3">
          <Button type="submit" disabled={isLoading}>
            submit
          </Button>
          {isLoading && <CircularProgress size={18} />}
        </div>
      </form>
    </div>
  );
}

export default Complaints;
